"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var SvgSad = function SvgSad(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return (0, _jsxRuntime.jsxs)("svg", _objectSpread(_objectSpread({
    fill: "none",
    viewBox: "0 0 80 80"
  }, props), {}, {
    children: [title ? (0, _jsxRuntime.jsx)("title", {
      children: title
    }) : null, (0, _jsxRuntime.jsx)("path", {
      fill: "#fff",
      d: "M0 0H80V80H0z"
    }), (0, _jsxRuntime.jsx)("circle", {
      cx: "40",
      cy: "40",
      r: "40",
      fill: "#EDE6FF"
    }), (0, _jsxRuntime.jsx)("path", {
      fill: "#6542BE",
      d: "M40 50a2 2 0 100-4 2 2 0 000 4zM34.586 43.414L32 40.828l-2.586 2.586-2.828-2.828L29.172 38l-2.586-2.586 2.828-2.828L32 35.172l2.586-2.586 2.828 2.828L34.828 38l2.586 2.586-2.828 2.828zM48 40.828l2.586 2.586 2.828-2.828L50.828 38l2.586-2.586-2.828-2.828L48 35.172l-2.586-2.586-2.828 2.828L45.172 38l-2.586 2.586 2.828 2.828L48 40.828z"
    }), (0, _jsxRuntime.jsx)("path", {
      fill: "#6542BE",
      fillRule: "evenodd",
      d: "M40 20c-11.046 0-20 8.954-20 20s8.954 20 20 20 20-8.954 20-20-8.954-20-20-20zM24 40c0-8.837 7.163-16 16-16s16 7.163 16 16-7.163 16-16 16-16-7.163-16-16z",
      clipRule: "evenodd"
    })]
  }));
};

var _default = SvgSad;
exports["default"] = _default;